window.global ||= window;

export {};
